window.global ||= window;

export {};
